import React from 'react';
import { Helmet } from 'react-helmet';
import Privacy from '../../Componet/PrivicyPolicy';

function PrivacyPolicy() {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | epicfinal</title>
        <meta
          name="description"
          content="Learn how epicfinal collects, uses, stores and protects personal information across its website, cloud, hosting and managed services."
        />
        <link rel="canonical" href="https://epicfinal.com/privacy_policy" />
      </Helmet>
      <div id="main-content">
        <Privacy />
      </div>
    </>
  );
}

export default PrivacyPolicy;
